var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("The 1099-K file is based on the deposits we send to your account in a year.")])}
var staticRenderFns = []

export { render, staticRenderFns }